import React from 'react';
import { Tag } from 'Components/frameworks/tag/Tag';
type Props = {
  className?: string;
  label: string;
};
export const AccommodationRoomTag = ({ className, label }: Props) => (
  <Tag className={className}>{label}</Tag>
);
